import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React from 'react';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';

export default function ViewJson(props: VisualisationContextProps) {
    const { state, height } = props;

    const style = { height };
    const data = { ...state };
    data.screenshot = state?.screenshot ? '(included)' : '(none included)';
    return (
        <div className="view-json" style={style}>
            <JsonPanel data={data} />
        </div>
    );
}
